<template>
  <div class="koselugo-tabs" :ref="`koselugo-tabs_${_uid}`">
    <div class="koselugo-tabs__head">
      <div
        class="koselugo-tabs__item"
        :class="{ 'koselugo-tabs__item_active': activeTab === 0 }"
        @click="choiceTab(0)"
      >
        <svg
          class="mr-2 mb-sm-2"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="19.25"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M15.8824 15.8824H10V24.1176H15.8824V30H24.1176V24.1176H30V15.8824H24.1176V10H15.8824V15.8824Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
        </svg>
        Бремя НФ1
      </div>
      <div
        class="koselugo-tabs__item"
        :class="{ 'koselugo-tabs__item_active': activeTab === 1 }"
        @click="choiceTab(1)"
      >
        <svg
          class="mr-2 mb-sm-2"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20.333"
            cy="20"
            r="19.25"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M20.5642 13.8889C21.9928 13.8889 23.1509 12.7308 23.1509 11.3022C23.1509 9.87367 21.9928 8.71558 20.5642 8.71558C19.1356 8.71558 17.9775 9.87367 17.9775 11.3022C17.9775 12.7308 19.1356 13.8889 20.5642 13.8889Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M29.0574 22.8535C30.4859 22.8535 31.644 21.6954 31.644 20.2668C31.644 18.8383 30.4859 17.6802 29.0574 17.6802C27.6288 17.6802 26.4707 18.8383 26.4707 20.2668C26.4707 21.6954 27.6288 22.8535 29.0574 22.8535Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M20.5642 31.2842C21.9928 31.2842 23.1509 30.1261 23.1509 28.6975C23.1509 27.2689 21.9928 26.1108 20.5642 26.1108C19.1356 26.1108 17.9775 27.2689 17.9775 28.6975C17.9775 30.1261 19.1356 31.2842 20.5642 31.2842Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M11.9597 27.4885C13.3883 27.4885 14.5464 26.3304 14.5464 24.9019C14.5464 23.4733 13.3883 22.3152 11.9597 22.3152C10.5311 22.3152 9.37305 23.4733 9.37305 24.9019C9.37305 26.3304 10.5311 27.4885 11.9597 27.4885Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M11.9597 17.373C13.3883 17.373 14.5464 16.215 14.5464 14.7864C14.5464 13.3578 13.3883 12.1997 11.9597 12.1997C10.5311 12.1997 9.37305 13.3578 9.37305 14.7864C9.37305 16.215 10.5311 17.373 11.9597 17.373Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M20.5596 21.3201C21.7133 21.3201 22.6485 20.3849 22.6485 19.2312C22.6485 18.0776 21.7133 17.1423 20.5596 17.1423C19.4059 17.1423 18.4707 18.0776 18.4707 19.2312C18.4707 20.3849 19.4059 21.3201 20.5596 21.3201Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M14.1865 13.4668L18.0665 11.969"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M22.3779 13.1511L27.2135 18.4533"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M27.4749 22.3113L22.4082 26.8846"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M13.3818 16.9465L18.9596 26.671"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M14.249 26.1069L17.9779 27.8358"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M12.9287 22.502L19.1643 13.4753"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M14.3418 15.8003L18.7062 18.267"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M22.6533 19.4663L26.4711 19.7552"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M20.5596 21.3247L20.564 26.1069"
            stroke="#9A3374"
            stroke-width="1.5"
          />
        </svg>
        Критерии диагноза НФ1
      </div>
      <div
        class="koselugo-tabs__item"
        :class="{ 'koselugo-tabs__item_active': activeTab === 2 }"
        @click="choiceTab(2)"
      >
        <svg
          class="mr-2 mb-sm-2"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="19.9997"
            cy="19.2499"
            r="2.16667"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M13 20.4166C17.6667 18.0833 16.8889 14.3888 15.9167 12.8333C18.7167 16.0999 20.5833 14.1944 21.1667 12.8333C22.1 15.6333 25.0556 15.5555 26.4167 15.1666C23.6167 16.5666 25.25 19.2499 26.4167 20.4166C23.15 20.4166 23.1111 23.9166 23.5 25.6666C20.2333 22.8666 17.8611 25.6666 17.0833 27.4166C18.4833 23.2166 14.9444 20.9999 13 20.4166Z"
            stroke="#9A3374"
            stroke-width="1.5"
          />
          <path
            d="M15.333 8.16675C15.9163 9.33342 16.8497 11.9001 15.9163 12.8334"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M20 7C20.0002 8.16667 19.9997 11.0833 21.1667 12.25"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M23.5 7C23.4998 8.16667 22.3336 11.0833 21.1667 12.25"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M25.25 8.75C24.6667 9.91667 22.3336 11.0833 21.1667 12.25"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M29.333 11.6667C28.7497 12.8334 27.5833 14.0001 26.4163 15.1668"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M31.083 17.5C30.4997 18.6667 28.7497 19.8333 26.9997 20.4167"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M32.833 20.4165C31.083 20.4166 28.7497 19.8331 26.9997 20.4165"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M31.083 22.7501C29.333 22.7501 28.7497 21.0001 26.9997 20.4167"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M28.167 28.0001C25.8337 28.5834 25.2503 26.8334 23.5003 25.6667"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M26.417 30.3334C24.0837 29.7501 25.2503 26.8334 23.5003 25.6667"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M22.3327 30.9168C23.4994 28.5834 24.0831 27.4168 23.4997 25.6667"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M31.083 14.5833C29.9163 14.5833 27.5833 14 26.4163 15.1667"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M12.417 9.91675C13.0003 11.0834 15.3337 11.6668 15.917 12.8334"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M10.667 11.6667C11.2503 12.8334 14.167 13.4168 15.917 12.8334"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M7.16699 17.5C8.33366 17.5 9.50033 21 13.0003 20.4167"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M6 19.8333C7.16667 20.4166 9.50001 20.9999 13 20.4166"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M7.16699 23.3334C8.33366 22.1668 8.33366 21.0001 11.8337 20.4167"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M13 29.1666C14.75 28.5833 15.9167 28.5833 17.0833 26.8333"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M15.917 33.25C17.0837 29.75 16.5003 28 17.667 26.25"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M19.4171 32.6666C17.6671 29.7499 15.9172 28.5833 17.0838 26.8333"
            stroke="#9A3374"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <circle
            cx="20.667"
            cy="20"
            r="19.25"
            stroke="#9A3374"
            stroke-width="1.5"
          />
        </svg>
        Плексиформная нейрофиброма
      </div>
    </div>
    <div class="text-1">
      <div class="koselugo-tabs__content">
        <div v-if="activeTab === 0">
          <div class="text-1">
            <b class="mb-4 d-block"
              >Нейрофиброматоз 1 типа, общая информация о заболевании:</b
            >
            <div class="mb-8">
              <div class="d-flex mb-4" style="align-items: center">
                <div style="flex-shrink: 0" class="mr-2">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 9.38674V10.0001C14.6665 11.4377 14.201 12.8365 13.3402 13.988C12.4794 15.1394 11.2695 15.9817 9.89089 16.3893C8.51227 16.797 7.03882 16.748 5.6903 16.2498C4.34177 15.7516 3.19042 14.8308 2.40796 13.6248C1.6255 12.4188 1.25385 10.9921 1.34844 9.55762C1.44303 8.12312 1.99879 6.75762 2.93284 5.66479C3.86689 4.57195 5.12917 3.81033 6.53144 3.4935C7.93371 3.17668 9.40083 3.32163 10.714 3.90674"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 4.66675L8 11.3401L6 9.34008"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  это наследственное генетическое заболевание<sup>6,7</sup>;
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div style="flex-shrink: 0" class="mr-2">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 9.38674V10.0001C14.6665 11.4377 14.201 12.8365 13.3402 13.988C12.4794 15.1394 11.2695 15.9817 9.89089 16.3893C8.51227 16.797 7.03882 16.748 5.6903 16.2498C4.34177 15.7516 3.19042 14.8308 2.40796 13.6248C1.6255 12.4188 1.25385 10.9921 1.34844 9.55762C1.44303 8.12312 1.99879 6.75762 2.93284 5.66479C3.86689 4.57195 5.12917 3.81033 6.53144 3.4935C7.93371 3.17668 9.40083 3.32163 10.714 3.90674"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 4.66675L8 11.3401L6 9.34008"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  встречается у 1 из 2 500-3 000 новорожденных<sup>8-10</sup>;
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div style="flex-shrink: 0" class="mr-2">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 9.38674V10.0001C14.6665 11.4377 14.201 12.8365 13.3402 13.988C12.4794 15.1394 11.2695 15.9817 9.89089 16.3893C8.51227 16.797 7.03882 16.748 5.6903 16.2498C4.34177 15.7516 3.19042 14.8308 2.40796 13.6248C1.6255 12.4188 1.25385 10.9921 1.34844 9.55762C1.44303 8.12312 1.99879 6.75762 2.93284 5.66479C3.86689 4.57195 5.12917 3.81033 6.53144 3.4935C7.93371 3.17668 9.40083 3.32163 10.714 3.90674"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 4.66675L8 11.3401L6 9.34008"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  один из самых распространенных синдромов с генетической
                  предрасположенностью к возникновению опухолей<sup>6-8</sup>;
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div style="flex-shrink: 0" class="mr-2">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 9.38674V10.0001C14.6665 11.4377 14.201 12.8365 13.3402 13.988C12.4794 15.1394 11.2695 15.9817 9.89089 16.3893C8.51227 16.797 7.03882 16.748 5.6903 16.2498C4.34177 15.7516 3.19042 14.8308 2.40796 13.6248C1.6255 12.4188 1.25385 10.9921 1.34844 9.55762C1.44303 8.12312 1.99879 6.75762 2.93284 5.66479C3.86689 4.57195 5.12917 3.81033 6.53144 3.4935C7.93371 3.17668 9.40083 3.32163 10.714 3.90674"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 4.66675L8 11.3401L6 9.34008"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  обычно манифестирует в раннем возрасте и прогрессирует в
                  процессе жизни<sup>6-8</sup>;
                </div>
              </div>
              <div class="d-flex" style="align-items: center">
                <div style="flex-shrink: 0" class="mr-2">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6673 9.38674V10.0001C14.6665 11.4377 14.201 12.8365 13.3402 13.988C12.4794 15.1394 11.2695 15.9817 9.89089 16.3893C8.51227 16.797 7.03882 16.748 5.6903 16.2498C4.34177 15.7516 3.19042 14.8308 2.40796 13.6248C1.6255 12.4188 1.25385 10.9921 1.34844 9.55762C1.44303 8.12312 1.99879 6.75762 2.93284 5.66479C3.86689 4.57195 5.12917 3.81033 6.53144 3.4935C7.93371 3.17668 9.40083 3.32163 10.714 3.90674"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.6667 4.66675L8 11.3401L6 9.34008"
                      stroke="#830051"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  может поражать различные  системы органов<sup>6,7</sup>.
                </div>
              </div>
            </div>
            <b class="mb-4 d-block"
              >Осложнения НФ1 многогранны и способны привести
              к<sup>6,7</sup>:</b
            >
            <div class="mb-8">
              <div class="d-md-flex">
                <div class="mr-4 mr-xs-0">
                  <div class="d-flex mb-4" style="align-items: center">
                    <div class="mr-2" style="flex-shrink: 0">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="25"
                          cy="25"
                          r="24.25"
                          stroke="#830051"
                          stroke-width="1.5"
                        />
                        <path
                          d="M17.5 28.5L15.2626 22.2353C15.1083 21.8032 15.2678 21.3214 15.6496 21.0669L19 18.8333M19 18.8333L20.7481 17.6679C20.9123 17.5584 21.1054 17.5 21.3028 17.5H22.5858C22.851 17.5 23.1054 17.6054 23.2929 17.7929L24.7071 19.2071C24.8946 19.3946 25 19.649 25 19.9142V24.5C25 25.0523 25.4477 25.5 26 25.5H30.882C31.2607 25.5 31.607 25.714 31.7764 26.0528L35.2139 32.9277C35.3883 33.2766 35.344 33.695 35.1003 33.9996L34.4486 34.8142C33.9998 35.3752 33.1235 35.294 32.7854 34.6601L29.7824 29.0294C29.6086 28.7035 29.2693 28.5 28.9 28.5H22.5588C22.2115 28.5 21.8891 28.3198 21.7071 28.0241L18.2396 22.3893C18.0874 22.1421 18.0502 21.8409 18.1377 21.5641L19 18.8333Z"
                          stroke="#9A3374"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <circle
                          cx="22"
                          cy="14"
                          r="2.25"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <mask id="path-4-inside-1_2510_6019" fill="white">
                          <path
                            d="M29.7482 33.2434C30.1356 33.39 30.3337 33.8248 30.1535 34.1978C29.289 35.9874 27.8199 37.4255 25.9936 38.2488C23.9385 39.1754 21.5995 39.2476 19.4911 38.4496C17.3827 37.6516 15.6777 36.0487 14.7512 33.9936C13.9278 32.1674 13.779 30.1169 14.3161 28.2034C14.428 27.8046 14.8644 27.61 15.2518 27.7566C15.6392 27.9032 15.8301 28.3356 15.7258 28.7364C15.3251 30.2755 15.4588 31.9137 16.1186 33.3771C16.8817 35.0696 18.2858 36.3896 20.0221 37.0467C21.7584 37.7039 23.6847 37.6445 25.3771 36.8814C26.8405 36.2216 28.0254 35.0825 28.7442 33.6639C28.9314 33.2944 29.3608 33.0968 29.7482 33.2434Z"
                          />
                        </mask>
                        <path
                          d="M29.7482 33.2434C30.1356 33.39 30.3337 33.8248 30.1535 34.1978C29.289 35.9874 27.8199 37.4255 25.9936 38.2488C23.9385 39.1754 21.5995 39.2476 19.4911 38.4496C17.3827 37.6516 15.6777 36.0487 14.7512 33.9936C13.9278 32.1674 13.779 30.1169 14.3161 28.2034C14.428 27.8046 14.8644 27.61 15.2518 27.7566C15.6392 27.9032 15.8301 28.3356 15.7258 28.7364C15.3251 30.2755 15.4588 31.9137 16.1186 33.3771C16.8817 35.0696 18.2858 36.3896 20.0221 37.0467C21.7584 37.7039 23.6847 37.6445 25.3771 36.8814C26.8405 36.2216 28.0254 35.0825 28.7442 33.6639C28.9314 33.2944 29.3608 33.0968 29.7482 33.2434Z"
                          stroke="#9A3374"
                          stroke-width="3"
                          mask="url(#path-4-inside-1_2510_6019)"
                        />
                      </svg>
                    </div>
                    <div>инвалидизации;</div>
                  </div>
                  <div class="d-flex mb-4" style="align-items: center">
                    <div class="mr-2" style="flex-shrink: 0">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="25"
                          cy="25"
                          r="24.25"
                          stroke="#830051"
                          stroke-width="1.5"
                        />
                        <path
                          d="M33.0207 37V31C33.0207 30.3333 33.2207 28.6 34.0207 27C35.0207 25 35.5207 24 35.5207 22C35.5207 20 34.5195 11 25.5207 11C16.5195 11 14.5207 17.8333 14.5207 22.5C14.1874 23.8333 13.0867 25.9346 12.5207 26.5C11.5197 27.5 12.0207 28.5 13.5207 29C15.0207 29.5 15.52 30 15.52 33C15.52 35.4 18.1867 35.6667 19.52 35.5C20.8533 35.5 23.62 34.8 24.02 32"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M26.1396 25.1193H24.3791C24.3854 24.5135 24.439 24.0182 24.54 23.6333C24.6472 23.242 24.8208 22.8855 25.0605 22.5637C25.3003 22.2419 25.619 21.8759 26.0165 21.4657C26.3068 21.1692 26.5718 20.8915 26.8116 20.6328C27.0577 20.3678 27.2565 20.0838 27.4079 19.7809C27.5593 19.4718 27.6351 19.1026 27.6351 18.6735C27.6351 18.2381 27.5562 17.8627 27.3984 17.5472C27.247 17.2317 27.0198 16.9887 26.7169 16.8184C26.4204 16.648 26.0512 16.5628 25.6095 16.5628C25.2435 16.5628 24.8965 16.6291 24.5684 16.7616C24.2402 16.8941 23.9752 17.0992 23.7733 17.3768C23.5714 17.6481 23.4672 18.0047 23.4609 18.4464H21.7099C21.7225 17.7333 21.8992 17.1212 22.2399 16.6101C22.587 16.099 23.0539 15.7078 23.6408 15.4364C24.2276 15.1651 24.8839 15.0294 25.6095 15.0294C26.4109 15.0294 27.0924 15.1746 27.654 15.4648C28.2219 15.7551 28.6541 16.1716 28.9507 16.7142C29.2473 17.2506 29.3956 17.8879 29.3956 18.6262C29.3956 19.1941 29.2788 19.7178 29.0454 20.1974C28.8182 20.6707 28.5248 21.1155 28.1651 21.532C27.8054 21.9485 27.4237 22.346 27.0198 22.7246C26.6728 23.0464 26.4393 23.4093 26.3194 23.8131C26.1995 24.2169 26.1396 24.6523 26.1396 25.1193ZM24.3033 28.1197C24.3033 27.8358 24.3917 27.596 24.5684 27.4004C24.745 27.2048 25.0006 27.107 25.335 27.107C25.6758 27.107 25.9345 27.2048 26.1112 27.4004C26.2879 27.596 26.3762 27.8358 26.3762 28.1197C26.3762 28.3911 26.2879 28.6245 26.1112 28.8202C25.9345 29.0158 25.6758 29.1136 25.335 29.1136C25.0006 29.1136 24.745 29.0158 24.5684 28.8202C24.3917 28.6245 24.3033 28.3911 24.3033 28.1197Z"
                          fill="#9A3374"
                        />
                      </svg>
                    </div>
                    <div>когнитивным нарушениям;</div>
                  </div>
                  <div class="d-flex mb-4" style="align-items: center">
                    <div class="mr-2" style="flex-shrink: 0">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="17.0166"
                          y="10.75"
                          width="15.2302"
                          height="20.1508"
                          rx="7.61508"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M20 21V21C20.6124 22.3123 22.4157 22.4697 23.2461 21.2833L23.4444 21"
                          stroke="#9A3374"
                        />
                        <path
                          d="M29.4443 21V21C28.8319 22.3123 27.0287 22.4697 26.1982 21.2833L25.9999 21"
                          stroke="#9A3374"
                        />
                        <path
                          d="M17 17.4603C18.4414 17.7349 21.3306 17.7567 23.0421 16.1409C23.5468 15.6645 24.3967 15.5313 24.9312 15.974C26.6718 17.4159 29.4731 18.8941 32.5 17.4603"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M32.5039 20.8257C33.488 19.5955 35.4563 23.532 32.5039 23.778"
                          stroke="#9A3374"
                        />
                        <path
                          d="M16.8408 20.8257C15.8567 19.5955 13.8884 23.532 16.8408 23.778"
                          stroke="#9A3374"
                        />
                        <path
                          d="M13.0665 40.508C12.7385 37.9657 13.4602 32.881 18.9713 32.881H21.1697C21.722 32.881 22.1697 32.4333 22.1697 31.881V30.6667"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M36.6854 40.508C37.0135 37.9657 36.2918 32.881 30.7807 32.881H28.5822C28.0299 32.881 27.5822 32.4333 27.5822 31.881V30.6667"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M21.9238 32.635C22.7439 34.1112 25.0238 36.1779 27.5826 32.635"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M33.1966 33C32.3633 33 30.5966 33.6 30.1966 36C29.6966 39 28.1966 34 27.6966 36.5C27.1966 39 26.1964 40.5 28.1964 40.5C29.2976 40.8333 31.6 41.2 32 40C32.5 38.5 36 41 36.5 39.5"
                          stroke="#9A3374"
                        />
                        <path
                          d="M17.5 25.5001C17.6667 25.0001 18.2 24.1001 19 24.5001C20 25.0001 21 24.4999 21.5 24.5C22 24.5001 22.5 26 22 26.5C21.5 27 21.5 27.5 21.5 28C21.5 28.5 22 29.5 21 29.5"
                          stroke="#9A3374"
                        />
                        <circle
                          cx="25"
                          cy="25"
                          r="24.25"
                          stroke="#830051"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <div>серьезным косметическим дефектам;</div>
                  </div>
                </div>
                <div>
                  <div class="d-flex mb-4" style="align-items: center">
                    <div class="mr-2" style="flex-shrink: 0">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="25"
                          cy="25"
                          r="24.25"
                          stroke="#830051"
                          stroke-width="1.5"
                        />
                        <path
                          d="M23.9147 9.41096C24.3946 8.57119 25.6054 8.57119 26.0853 9.41096L40.6389 34.8798C41.1151 35.7131 40.5134 36.75 39.5536 36.75H10.4464C9.48658 36.75 8.88487 35.7131 9.36106 34.8798L23.9147 9.41096Z"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M26 18L25.822 27H24.1809L24 18H26Z"
                          fill="#9A3374"
                        />
                        <circle cx="25" cy="31" r="1" fill="#9A3374" />
                      </svg>
                    </div>
                    <div>жизнеугрожающим состояниям;</div>
                  </div>
                  <div class="d-flex" style="align-items: center">
                    <div class="mr-2" style="flex-shrink: 0">
                      <svg
                        width="50"
                        height="50"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="25"
                          cy="25"
                          r="24.25"
                          stroke="#830051"
                          stroke-width="1.5"
                        />
                        <path
                          d="M13.9111 35V34.149V26.0647L14.8649 25.777C15.2113 25.5669 15.4978 25.2704 15.6967 24.9162C15.8955 24.562 16 24.1622 16 23.7555V20.3627C15.9998 19.736 15.7521 19.1351 15.3113 18.692C14.8704 18.2489 14.2726 18 13.6493 18H10.3507C9.72738 18 9.12956 18.2489 8.68874 18.692C8.24791 19.1351 8.00017 19.736 8 20.3627V23.7529C7.99998 24.1657 8.10754 24.5713 8.31197 24.9292C8.5164 25.2872 8.81056 25.585 9.16514 25.7931L10.1111 26.0647V37.5"
                          stroke="#9A3374"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M38.9111 37.5V34.149V26.0647L39.8649 25.777C40.2113 25.5669 40.4978 25.2704 40.6967 24.9162C40.8955 24.562 41 24.1622 41 23.7555V20.3627C40.9998 19.736 40.7521 19.1351 40.3113 18.692C39.8704 18.2489 39.2726 18 38.6493 18H35.3507C34.7274 18 34.1296 18.2489 33.6887 18.692C33.2479 19.1351 33.0002 19.736 33 20.3627V23.7529C33 24.1657 33.1075 24.5713 33.312 24.9292C33.5164 25.2872 33.8106 25.585 34.1651 25.7931L35.1111 26.0647V35"
                          stroke="#9A3374"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M14.7513 13.1386C14.7526 14.4224 13.6476 15.5272 12.202 15.5272C10.7565 15.5272 9.64916 14.4224 9.64781 13.1386C9.64647 11.8548 10.7515 10.75 12.197 10.75C13.6426 10.75 14.7499 11.8548 14.7513 13.1386Z"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M39.7513 13.1386C39.7526 14.4224 38.6476 15.5272 37.202 15.5272C35.7565 15.5272 34.6492 14.4224 34.6478 13.1386C34.6465 11.8548 35.7515 10.75 37.197 10.75C38.6426 10.75 39.7499 11.8548 39.7513 13.1386Z"
                          stroke="#9A3374"
                          stroke-width="1.5"
                        />
                        <path
                          d="M15 37H34.5"
                          stroke="#9A3374"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <div>затруднению процесса социализации.</div>
                  </div>
                </div>
              </div>
            </div>
            Раннее выявление НФ1 позволяет своевременно принять меры
            профилактики и коррекции осложнений заболевания, чтобы избежать
            необратимых последствий и сохранить качество жизни
            пациентов<sup>11</sup>.
            <br />
            <br />
            <b class="mb-4 d-block"
              >Проявления НФ1 широко варьируют и способны вовлекать различные
              системы органов<sup>6,7,13</sup></b
            >
            <div class="full-screen">
              <div class="full-screen__trigger d-md-none">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="8" fill="#830051"></rect>
                  <path
                    d="M23 11H29V17"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M17 29H11V23"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M29 11L22 18"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M11 29L18 22"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
              <picture class="mb-4">
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/4.jpg
                  `"
                  media="(max-width: 767px)"
                />
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/4.jpg
                  `"
                  media="(max-width: 1220px)"
                />
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/4.jpg
                  `"
                  media="(min-width: 1221px)"
                />
                <img
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/4.jpg`"
                />
              </picture>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 1">
          <div class="koselugo-tabs__body">
            <div
              class="koselugo-tabs__block"
              v-for="(block, ind) in modals[0]"
              :key="ind"
            >
              <div
                class="koselugo-tabs__block-title"
                :class="{ 'mb-0': !block.text }"
                v-html="block.title"
              ></div>
              <div
                class="
                  d-inline-flex
                  px-4
                  ml-auto
                  mt-auto
                  koselugo-tabs__block-button
                  button button_empty-pink button_small
                "
                v-if="block.text"
                @click="currentModal = ind"
              >
                Подробнее
                <svg
                  class="ml-2"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 3L11 8L6 13"
                    stroke="#830051"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="text-1">
            <b class="d-block mb-4 mt-4"
              >НФ1 диагностируют у детей родителей с НФ1 при выполнении 1 или
              более вышеуказанных критериев.</b
            >
            * Если у пациента присутствуют только критерии, проявляющиеся в виде
            гиперпигментации кожи (пятна цвета «кофе с молоком» и пятна, похожие
            на веснушки), необходимо генетическое тестирование для подтверждения
            диагноза НФ1. По крайней мере одно из двух гиперпигментных
            проявлений должно быть билатеральным.
            <br />
            <br />
            ** Наличие дисплазии крыла клиновидной кости в сочетании
            с плексиформной нейрофибромой в области ипсилатеральной орбиты
            расценивают как соответствие одному критерию.
          </div>
          <div class="koselugo-tabs__modal" v-if="currentModal !== null">
            <div
              class="koselugo-tabs__modal-overlay"
              @click="currentModal = null"
            ></div>
            <div class="koselugo-tabs__modal-content">
              <div class="koselugo-tabs__modal-head">
                <div
                  class="koselugo-tabs__modal-title"
                  v-html="modals[0][currentModal].modalTitle"
                ></div>
                <div
                  class="koselugo-tabs__modal-close"
                  @click="currentModal = null"
                >
                  <svg
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 7L25 25"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                    <path
                      d="M25 7L7 25"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div
                class="koselugo-tabs__modal-body"
                v-html="modals[0][currentModal].text"
              ></div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 2">
          <div class="pa-4 mb-4" style="color: #fff; background-color: #6ba2ba">
            Плексиформные нейрофибромы (ПН) – это доброкачественные опухоли
            оболочек периферических нервов<sup>16-18</sup>.
          </div>
          <div class="d-xl-flex">
            <div
              class="d-flex d-md-block mb-4 pa-4 pa-md-0"
              style="align-items: center; flex-basis: 33.3%"
            >
              <div style="flex-shrink: 0" class="mr-sm-4 mb-sm-0 mb-4">
                <svg
                  class="mx-auto"
                  width="51"
                  height="50"
                  viewBox="0 0 51 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25.168"
                    cy="25"
                    r="24.25"
                    stroke="#830051"
                    stroke-width="1.5"
                  />
                  <path
                    d="M25.3166 37.5C31.3166 30.1667 39.7166 15 25.3166 13C19.3166 13.5 10.8167 19.1 24.8167 37.5"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <circle cx="25.168" cy="21" r="3.5" stroke="#9A3374" />
                </svg>
              </div>
              <div style="text-align: center" class="d-none d-md-block">
                Локализация и размеры ПН варьируют
              </div>
              <div class="d-md-none">Локализация и размеры ПН варьируют</div>
            </div>
            <div
              class="d-flex d-md-block mb-4 pa-4 pa-md-0"
              style="align-items: center; flex-basis: 33.3%"
            >
              <div style="flex-shrink: 0" class="mr-sm-4 mb-sm-0 mb-4">
                <svg
                  class="mx-auto"
                  width="51"
                  height="50"
                  viewBox="0 0 51 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25.5"
                    cy="25"
                    r="24.25"
                    stroke="#830051"
                    stroke-width="1.5"
                  />
                  <path
                    d="M37.25 13.4916C37.2453 13.0774 36.9058 12.7454 36.4916 12.75L29.742 12.8259C29.3278 12.8305 28.9958 13.1701 29.0005 13.5843C29.0051 13.9985 29.3447 14.3304 29.7589 14.3258L35.7585 14.2584L35.8259 20.258C35.8305 20.6722 36.1701 21.0042 36.5843 20.9995C36.9985 20.9949 37.3304 20.6553 37.3258 20.2411L37.25 13.4916ZM13.75 36.0084C13.7547 36.4226 14.0942 36.7546 14.5084 36.75L21.258 36.6741C21.6722 36.6695 22.0042 36.3299 21.9995 35.9157C21.9949 35.5015 21.6553 35.1696 21.2411 35.1742L15.2415 35.2416L15.1741 29.242C15.1695 28.8278 14.8299 28.4958 14.4157 28.5005C14.0015 28.5051 13.6696 28.8447 13.6742 29.2589L13.75 36.0084ZM35.9637 12.9757L13.9637 35.4757L15.0363 36.5243L37.0363 14.0243L35.9637 12.9757Z"
                    fill="#9A3374"
                  />
                  <path
                    d="M13.75 13.4916C13.7547 13.0774 14.0942 12.7454 14.5084 12.75L21.258 12.8259C21.6722 12.8305 22.0042 13.1701 21.9995 13.5843C21.9949 13.9985 21.6553 14.3304 21.2411 14.3258L15.2415 14.2584L15.1741 20.258C15.1695 20.6722 14.8299 21.0042 14.4157 20.9995C14.0015 20.9949 13.6696 20.6553 13.6742 20.2411L13.75 13.4916ZM37.25 36.0084C37.2453 36.4226 36.9058 36.7546 36.4916 36.75L29.742 36.6741C29.3278 36.6695 28.9958 36.3299 29.0005 35.9157C29.0051 35.5015 29.3447 35.1696 29.7589 35.1742L35.7585 35.2416L35.8259 29.242C35.8305 28.8278 36.1701 28.4958 36.5843 28.5005C36.9985 28.5051 37.3304 28.8447 37.3258 29.2589L37.25 36.0084ZM15.0363 12.9757L37.0363 35.4757L35.9637 36.5243L13.9637 14.0243L15.0363 12.9757Z"
                    fill="#9A3374"
                  />
                </svg>
              </div>
              <div style="text-align: center" class="d-none d-md-block">
                ПН растут по ходу периферических нервов
              </div>
              <div class="d-md-none">
                ПН растут по ходу периферических нервов
              </div>
            </div>
            <div
              class="d-flex d-md-block mb-4 pa-4 pa-md-0"
              style="align-items: center; flex-basis: 33.3%"
            >
              <div style="flex-shrink: 0" class="mr-sm-4 mb-sm-0 mb-4">
                <svg
                  class="mx-auto"
                  width="51"
                  height="50"
                  viewBox="0 0 51 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25.168"
                    cy="25"
                    r="24.25"
                    stroke="#830051"
                    stroke-width="1.5"
                  />
                  <circle
                    cx="24.4293"
                    cy="23.9782"
                    r="3.05435"
                    stroke="#9A3374"
                    stroke-width="1.5"
                  />
                  <path
                    d="M15.2988 25.4999C21.3858 22.4565 20.3713 17.6376 19.1032 15.6086C22.7554 19.8695 25.1901 17.384 25.951 15.6086C27.1684 19.2608 31.0235 19.1594 32.7988 18.6521C29.1467 20.4782 31.2771 23.9782 32.7988 25.4999C28.538 25.4999 28.4872 30.0652 28.9945 32.3478C24.7336 28.6956 21.6394 32.3478 20.6249 34.6304C22.451 29.1521 17.8351 26.2608 15.2988 25.4999Z"
                    stroke="#9A3374"
                    stroke-width="1.5"
                  />
                  <path
                    d="M18.3418 9.52173C19.1027 11.0435 20.3201 14.3913 19.1027 15.6087"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M24.4297 8C24.4299 9.52174 24.4293 13.3261 25.9514 14.8478"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M28.9941 8C28.9939 9.52174 27.4728 13.3261 25.9507 14.8478"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M31.2773 10.2827C30.5165 11.8045 27.4733 13.3262 25.9513 14.8479"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M36.6035 14.0869C35.8426 15.6087 34.3213 17.1304 32.7992 18.6521"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M38.8848 21.6956C38.1239 23.2173 35.8413 24.739 33.5587 25.4999"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M41.168 25.4998C38.8854 25.4999 35.8419 24.7389 33.5593 25.4998"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M38.8848 28.5435C36.6022 28.5436 35.8413 26.2609 33.5587 25.5"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M35.082 35.3914C32.0386 36.1522 31.2777 33.8696 28.9951 32.3479"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M32.7988 38.4349C29.7553 37.674 31.2771 33.8696 28.9945 32.3479"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M27.4724 39.1957C28.9942 36.1522 29.7555 34.6305 28.9945 32.3479"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M38.8848 17.8914C37.363 17.8914 34.3199 17.1305 32.7978 18.6523"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14.5371 11.8042C15.298 13.3259 18.3415 14.0868 19.1023 15.6085"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M12.2539 14.0869C13.0148 15.6087 16.8191 16.3695 19.1017 15.6087"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7.68945 21.6956C9.21119 21.6956 10.7329 26.2608 15.2981 25.4999"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6.16797 24.7393C7.68971 25.5001 10.7332 26.261 15.2984 25.5001"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7.68945 29.3043C9.21119 27.7826 9.21119 26.2609 13.7764 25.5"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M15.2988 36.9131C17.5814 36.1522 19.1032 36.1522 20.6249 33.8696"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M19.1035 42.2391C20.6253 37.6739 19.8644 35.3913 21.3861 33.1086"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M23.669 41.4783C21.3863 37.674 19.1038 36.1522 20.6256 33.8696"
                    stroke="#9A3374"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div style="text-align: center" class="d-none d-md-block">
                Могут вовлекать множественные нервы и их ветви
              </div>
              <div class="d-md-none">
                Могут вовлекать множественные нервы и их ветви
              </div>
            </div>
          </div>
          ПН могут развиваться в любой области тела, где есть периферические
          нервы и способны вовлекать несколько областей
          тела<sup>6-8,12,13,15</sup>.
          <br />
          <br />
          В зависимости от локализации, ПН могут быть<sup>19</sup>:
          <div class="d-md-flex mt-4 mb-4">
            <div
              class="pa-4 mr-4 mr-sm-0 mb-sm-4"
              style="
                background-color: #f8f8f8;
                border-radius: 8px;
                border: 1px solid #6AA2B9;
                flex-basis: 50%;
              "
            >
              <b class="d-block mb-2">Поверхностными:</b>
              <ul>
                <li>их можно увидеть при общеклиническом осмотре;</li>
                <li>частота 58,5%.</li>
              </ul>
            </div>
            <div
              class="pa-4"
              style="
                background-color: #f8f8f8;
                border-radius: 8px;
                border: 1px solid #6AA2B9;
                flex-basis: 50%;
              "
            >
              <b class="d-block mb-2">Глубокими:</b>
              <ul>
                <li>
                  их можно увидеть только с помощью инструментальных методов
                  обследования (УЗИ, МРТ);
                </li>
                <li>частота 41,5%.</li>
              </ul>
            </div>
          </div>
          <b class="d-block mb-4"
            >Частота ПН различной локализации у детей<sup>20</sup></b
          >
          <div class="full-screen">
            <div class="full-screen__trigger d-md-none">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="#830051"></rect>
                <path
                  d="M23 11H29V17"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M17 29H11V23"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M29 11L22 18"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M11 29L18 22"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </div>
            <picture>
              <source
                :srcset="`
                  https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/5.jpg
                `"
                media="(max-width: 767px)"
              />
              <source
                :srcset="`
                  https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/5.jpg
                `"
                media="(max-width: 1220px)"
              />
              <source
                :srcset="`
                  https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/5.jpg
                `"
                media="(min-width: 1221px)"
              />
              <img
                class="mb-4"
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/5.jpg`"
              />
            </picture>
          </div>

          <div class="title-4 mb-4" style="color: #830051">
            Осложнения плексиформных нейрофибром
          </div>
          <div class="mb-4">
            Если ПН сдавливает периферические нервы, сосуды, органы и ткани, или
            локализуется на видимых участках тела, у пациента могут развиться
            клинически значимые осложнения.
            <b>В таких случаях ПН будет считаться симптоматической</b
            ><sup>6-8,12,13,21,22</sup>.
          </div>
          <b class="d-block mb-4">
            Частота симптоматических ПН<sup>21</sup>:
          </b>
          <picture>
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/6_mob.jpg
              `"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/6.jpg
              `"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/6.jpg
              `"
              media="(min-width: 1221px)"
            />
            <img
              class="d-none d-md-block mb-4"
              style="width: auto; max-width: 500px"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/6.jpg`"
            />
            <img
              class="d-md-none mb-4"
              style="width: auto; max-width: 100%"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/6.jpg`"
            />
          </picture>
          <b class="d-block mb-4">
            Характер осложнений варьирует, в зависимости от локализации ПН<sup
              >6-8,12,13,21,22</sup
            >
          </b>
          <div class="mb-4">
            <div class="d-md-flex">
              <div class="mr-4 mr-xs-0">
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <circle
                        cx="25"
                        cy="25"
                        r="3.25"
                        stroke="#9A3374"
                        stroke-width="1.5"
                      />
                      <mask id="path-3-inside-1_2510_7097" fill="white">
                        <path
                          d="M16.8264 12.0086C16.5836 11.6134 16.0649 11.4879 15.6834 11.7518C13.6427 13.1631 11.9671 15.0463 10.8021 17.2462C9.50589 19.6939 8.88924 22.4443 9.01632 25.2111C9.1434 27.978 10.0096 30.6603 11.5247 32.9789C12.8864 35.0627 14.7276 36.7844 16.8891 38.0027C17.2932 38.2305 17.7982 38.058 18.0037 37.6422C18.2093 37.2264 18.0373 36.7249 17.6347 36.4945C15.7417 35.411 14.1283 33.8925 12.9309 32.06C11.5799 29.9927 10.8076 27.6011 10.6943 25.1341C10.581 22.6671 11.1308 20.2148 12.2866 18.0323C13.311 16.0977 14.7784 14.4378 16.5642 13.1853C16.9439 12.919 17.0692 12.4038 16.8264 12.0086Z"
                        />
                      </mask>
                      <path
                        d="M16.8264 12.0086C16.5836 11.6134 16.0649 11.4879 15.6834 11.7518C13.6427 13.1631 11.9671 15.0463 10.8021 17.2462C9.50589 19.6939 8.88924 22.4443 9.01632 25.2111C9.1434 27.978 10.0096 30.6603 11.5247 32.9789C12.8864 35.0627 14.7276 36.7844 16.8891 38.0027C17.2932 38.2305 17.7982 38.058 18.0037 37.6422C18.2093 37.2264 18.0373 36.7249 17.6347 36.4945C15.7417 35.411 14.1283 33.8925 12.9309 32.06C11.5799 29.9927 10.8076 27.6011 10.6943 25.1341C10.581 22.6671 11.1308 20.2148 12.2866 18.0323C13.311 16.0977 14.7784 14.4378 16.5642 13.1853C16.9439 12.919 17.0692 12.4038 16.8264 12.0086Z"
                        stroke="#9A3374"
                        stroke-width="2"
                        mask="url(#path-3-inside-1_2510_7097)"
                      />
                      <mask id="path-4-inside-2_2510_7097" fill="white">
                        <path
                          d="M32.1864 11.9878C32.4221 11.604 32.9257 11.4823 33.2965 11.7379C35.3463 13.1507 37.0291 15.0391 38.1979 17.2462C39.4941 19.6939 40.1108 22.4443 39.9837 25.2111C39.8566 27.978 38.9904 30.6603 37.4753 32.9789C36.1091 35.0696 34.2603 36.7957 32.0896 38.0147C31.697 38.2352 31.2067 38.0678 31.0071 37.6641C30.8075 37.2604 30.9744 36.7734 31.3658 36.5505C33.2757 35.4623 34.9033 33.9334 36.1101 32.0867C37.4658 30.0121 38.2408 27.6121 38.3545 25.1363C38.4682 22.6606 37.9165 20.1996 36.7566 18.0094C35.7242 16.0599 34.2436 14.3883 32.4414 13.1296C32.0722 12.8717 31.9506 12.3715 32.1864 11.9878Z"
                        />
                      </mask>
                      <path
                        d="M32.1864 11.9878C32.4221 11.604 32.9257 11.4823 33.2965 11.7379C35.3463 13.1507 37.0291 15.0391 38.1979 17.2462C39.4941 19.6939 40.1108 22.4443 39.9837 25.2111C39.8566 27.978 38.9904 30.6603 37.4753 32.9789C36.1091 35.0696 34.2603 36.7957 32.0896 38.0147C31.697 38.2352 31.2067 38.0678 31.0071 37.6641C30.8075 37.2604 30.9744 36.7734 31.3658 36.5505C33.2757 35.4623 34.9033 33.9334 36.1101 32.0867C37.4658 30.0121 38.2408 27.6121 38.3545 25.1363C38.4682 22.6606 37.9165 20.1996 36.7566 18.0094C35.7242 16.0599 34.2436 14.3883 32.4414 13.1296C32.0722 12.8717 31.9506 12.3715 32.1864 11.9878Z"
                        stroke="#9A3374"
                        stroke-width="2"
                        mask="url(#path-4-inside-2_2510_7097)"
                      />
                      <mask id="path-5-inside-3_2510_7097" fill="white">
                        <path
                          d="M19.8982 18.4912C19.6495 18.1739 19.1883 18.1162 18.8922 18.3898C18.0407 19.1766 17.3475 20.1221 16.8529 21.1758C16.2547 22.4502 15.9638 23.8471 16.0036 25.2543C16.0434 26.6615 16.4127 28.0398 17.0819 29.2784C17.6352 30.3024 18.3808 31.2073 19.2754 31.9447C19.5865 32.2011 20.0437 32.1175 20.2741 31.7866C20.5045 31.4558 20.4203 31.0034 20.1133 30.7421C19.4041 30.1385 18.8111 29.4073 18.3664 28.5843C17.8058 27.5467 17.4964 26.392 17.463 25.2131C17.4297 24.0341 17.6734 22.8638 18.1746 21.7962C18.572 20.9493 19.1227 20.1858 19.7967 19.5432C20.0885 19.2649 20.1469 18.8085 19.8982 18.4912Z"
                        />
                      </mask>
                      <path
                        d="M19.8982 18.4912C19.6495 18.1739 19.1883 18.1162 18.8922 18.3898C18.0407 19.1766 17.3475 20.1221 16.8529 21.1758C16.2547 22.4502 15.9638 23.8471 16.0036 25.2543C16.0434 26.6615 16.4127 28.0398 17.0819 29.2784C17.6352 30.3024 18.3808 31.2073 19.2754 31.9447C19.5865 32.2011 20.0437 32.1175 20.2741 31.7866C20.5045 31.4558 20.4203 31.0034 20.1133 30.7421C19.4041 30.1385 18.8111 29.4073 18.3664 28.5843C17.8058 27.5467 17.4964 26.392 17.463 25.2131C17.4297 24.0341 17.6734 22.8638 18.1746 21.7962C18.572 20.9493 19.1227 20.1858 19.7967 19.5432C20.0885 19.2649 20.1469 18.8085 19.8982 18.4912Z"
                        stroke="#9A3374"
                        stroke-width="2"
                        mask="url(#path-5-inside-3_2510_7097)"
                      />
                      <mask id="path-6-inside-4_2510_7097" fill="white">
                        <path
                          d="M30.1022 18.4906C30.3507 18.1736 30.8114 18.116 31.1072 18.3893C31.959 19.1762 32.6524 20.1219 33.1471 21.1758C33.7453 22.4502 34.0362 23.8471 33.9964 25.2543C33.9566 26.6615 33.5873 28.0398 32.9181 29.2784C32.3646 30.3026 31.6189 31.2077 30.724 31.9452C30.4132 32.2013 29.9565 32.1178 29.7264 31.7872C29.4962 31.4567 29.5803 31.0048 29.887 30.7438C30.5967 30.14 31.19 29.4085 31.6349 28.585C32.1957 27.5472 32.5051 26.3923 32.5385 25.2131C32.5718 24.0339 32.3281 22.8634 31.8268 21.7955C31.4291 20.9482 30.8781 20.1844 30.2037 19.5415C29.9122 19.2636 29.8538 18.8076 30.1022 18.4906Z"
                        />
                      </mask>
                      <path
                        d="M30.1022 18.4906C30.3507 18.1736 30.8114 18.116 31.1072 18.3893C31.959 19.1762 32.6524 20.1219 33.1471 21.1758C33.7453 22.4502 34.0362 23.8471 33.9964 25.2543C33.9566 26.6615 33.5873 28.0398 32.9181 29.2784C32.3646 30.3026 31.6189 31.2077 30.724 31.9452C30.4132 32.2013 29.9565 32.1178 29.7264 31.7872C29.4962 31.4567 29.5803 31.0048 29.887 30.7438C30.5967 30.14 31.19 29.4085 31.6349 28.585C32.1957 27.5472 32.5051 26.3923 32.5385 25.2131C32.5718 24.0339 32.3281 22.8634 31.8268 21.7955C31.4291 20.9482 30.8781 20.1844 30.2037 19.5415C29.9122 19.2636 29.8538 18.8076 30.1022 18.4906Z"
                        stroke="#9A3374"
                        stroke-width="2"
                        mask="url(#path-6-inside-4_2510_7097)"
                      />
                    </svg>
                  </div>
                  <div>Болевой синдром</div>
                </div>
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <circle
                        cx="25.5"
                        cy="25.5"
                        r="5.75"
                        stroke="#9A3374"
                        stroke-width="1.5"
                      />
                      <path
                        d="M25 22.5C26.1667 22.5 28.6 23.2 29 26"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M8 26C10.3333 22.5 17.1 15.5 25.5 15.5C33.9 15.5 40.3333 22.5 42.5 26"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M8 26C10.3671 29.3333 17.2319 36 25.7536 36C34.2754 36 40.3019 29.3333 42.5 26"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div>Осложнения со стороны орбиты и органов зрения</div>
                </div>
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <path
                        d="M30 12H22L17 27H24.5L20.5 41.5L35.5 21H27L30 12Z"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div>Расстройства функции внутренних органов</div>
                </div>
              </div>
              <div>
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <path
                        d="M24.9998 13C18.9998 20.3333 10.5998 35.5 24.9998 37.5C30.9998 37 39.4998 31.4 25.4998 13"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M29 28.5C29.3333 29.8333 29.1 32.5 25.5 32.5"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div>Кровотечения</div>
                </div>
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <path
                        d="M20.8629 10.657L21.6103 10.7193V10.7193L20.8629 10.657ZM20.6645 13.0375L20.9446 13.7332L21.3736 13.5606L21.412 13.0998L20.6645 13.0375ZM17.6964 14.7732L17.3766 15.4516L17.7998 15.6511L18.1651 15.3587L17.6964 14.7732ZM15.5146 13.7448L15.1949 14.4232V14.4232L15.5146 13.7448ZM12.1221 14.8068L12.7717 15.1818L12.1221 14.8068ZM10.6 17.4432L9.95047 17.0682H9.95047L10.6 17.4432ZM11.3766 20.9122L11.8042 20.2961H11.8042L11.3766 20.9122ZM13.3812 22.3036L14.1236 22.4103L14.1895 21.9517L13.8088 21.6874L13.3812 22.3036ZM13.3812 25.6964L13.8088 26.3126L14.1895 26.0484L14.1236 25.5897L13.3812 25.6964ZM11.3766 27.0878L10.9489 26.4717H10.9489L11.3766 27.0878ZM10.6 30.5568L11.2495 30.1818H11.2495L10.6 30.5568ZM12.1221 33.1932L12.7717 32.8182H12.7717L12.1221 33.1932ZM15.5146 34.2552L15.8344 34.9336L15.5146 34.2552ZM17.6964 33.2268L18.1651 32.6413L17.7999 32.3489L17.3766 32.5484L17.6964 33.2268ZM20.6645 34.9625L21.412 34.9002L21.3736 34.4394L20.9446 34.2668L20.6645 34.9625ZM20.8629 37.343L21.6103 37.2807L20.8629 37.343ZM29.1391 37.343L28.3917 37.2807L29.1391 37.343ZM29.3326 35.0211L29.062 34.3216L28.6242 34.4909L28.5852 34.9588L29.3326 35.0211ZM32.3957 33.2694L32.7155 32.5909L32.295 32.3927L31.9304 32.6812L32.3957 33.2694ZM34.4873 34.2552L34.1675 34.9336L34.4873 34.2552ZM37.8798 33.1932L38.5293 33.5682L37.8798 33.1932ZM39.4019 30.5568L38.7524 30.1818L39.4019 30.5568ZM38.6254 27.0878L39.053 26.4717L38.6254 27.0878ZM36.751 25.7869L36.0095 25.6744L35.9394 26.1365L36.3234 26.403L36.751 25.7869ZM36.751 22.2132L36.3234 21.597L35.9394 21.8635L36.0095 22.3257L36.751 22.2132ZM38.6254 20.9122L39.053 21.5283L38.6254 20.9122ZM39.4019 17.4432L38.7524 17.8182L39.4019 17.4432ZM37.8798 14.8068L38.5293 14.4318V14.4318L37.8798 14.8068ZM34.4873 13.7448L34.8071 14.4232L34.4873 13.7448ZM32.3957 14.7307L31.9304 15.3189L32.295 15.6073L32.7155 15.4091L32.3957 14.7307ZM29.3326 12.9789L28.5852 13.0412L28.6242 13.5091L29.062 13.6784L29.3326 12.9789ZM29.1391 10.657L28.3917 10.7193L29.1391 10.657ZM21.6103 10.7193C21.6913 9.74749 22.5037 9 23.4789 9V7.5C21.7236 7.5 20.2613 8.84548 20.1155 10.5947L21.6103 10.7193ZM21.412 13.0998L21.6103 10.7193L20.1155 10.5947L19.9171 12.9752L21.412 13.0998ZM18.1651 15.3587C19.0013 14.6893 19.9364 14.1391 20.9446 13.7332L20.3845 12.3417C19.2385 12.803 18.1766 13.4281 17.2277 14.1877L18.1651 15.3587ZM15.1949 14.4232L17.3766 15.4516L18.0162 14.0948L15.8344 13.0664L15.1949 14.4232ZM12.7717 15.1818C13.2592 14.3373 14.3128 14.0075 15.1949 14.4232L15.8344 13.0664C14.2466 12.318 12.3503 12.9117 11.4726 14.4318L12.7717 15.1818ZM11.2495 17.8182L12.7717 15.1818L11.4726 14.4318L9.95047 17.0682L11.2495 17.8182ZM11.8042 20.2961C11.0031 19.74 10.7619 18.6628 11.2495 17.8182L9.95047 17.0682C9.07282 18.5884 9.50691 20.5275 10.9489 21.5283L11.8042 20.2961ZM13.8088 21.6874L11.8042 20.2961L10.9489 21.5283L12.9535 22.9197L13.8088 21.6874ZM14.0103 24C14.0103 23.4598 14.0489 22.9291 14.1236 22.4103L12.6388 22.1968C12.5541 22.786 12.5103 23.3881 12.5103 24H14.0103ZM14.1236 25.5897C14.0489 25.0709 14.0103 24.5402 14.0103 24H12.5103C12.5103 24.6119 12.5541 25.214 12.6388 25.8032L14.1236 25.5897ZM11.8042 27.704L13.8088 26.3126L12.9535 25.0803L10.9489 26.4717L11.8042 27.704ZM11.2495 30.1818C10.7619 29.3373 11.0031 28.26 11.8042 27.704L10.9489 26.4717C9.50691 27.4725 9.07282 29.4117 9.95047 30.9318L11.2495 30.1818ZM12.7717 32.8182L11.2495 30.1818L9.95047 30.9318L11.4726 33.5682L12.7717 32.8182ZM15.1949 33.5768C14.3128 33.9925 13.2592 33.6628 12.7717 32.8182L11.4726 33.5682C12.3503 35.0884 14.2466 35.682 15.8344 34.9336L15.1949 33.5768ZM17.3766 32.5484L15.1949 33.5768L15.8344 34.9336L18.0162 33.9053L17.3766 32.5484ZM20.9446 34.2668C19.9364 33.8609 19.0013 33.3107 18.1651 32.6413L17.2277 33.8124C18.1766 34.572 19.2385 35.197 20.3845 35.6583L20.9446 34.2668ZM21.6103 37.2807L21.412 34.9002L19.9171 35.0248L20.1155 37.4053L21.6103 37.2807ZM23.4789 39C22.5037 39 21.6913 38.2525 21.6103 37.2807L20.1155 37.4053C20.2613 39.1545 21.7236 40.5 23.4789 40.5V39ZM26.5232 39H23.4789V40.5H26.5232V39ZM28.3917 37.2807C28.3107 38.2525 27.4983 39 26.5232 39V40.5C28.2785 40.5 29.7407 39.1545 29.8865 37.4053L28.3917 37.2807ZM28.5852 34.9588L28.3917 37.2807L29.8865 37.4053L30.08 35.0834L28.5852 34.9588ZM31.9304 32.6812C31.0685 33.363 30.1032 33.9189 29.062 34.3216L29.6031 35.7206C30.7866 35.2629 31.883 34.6313 32.861 33.8576L31.9304 32.6812ZM34.8071 33.5768L32.7155 32.5909L32.076 33.9478L34.1675 34.9336L34.8071 33.5768ZM37.2303 32.8182C36.7427 33.6628 35.6892 33.9925 34.8071 33.5768L34.1675 34.9336C35.7553 35.682 37.6517 35.0884 38.5293 33.5682L37.2303 32.8182ZM38.7524 30.1818L37.2303 32.8182L38.5293 33.5682L40.0515 30.9318L38.7524 30.1818ZM38.1977 27.704C38.9988 28.26 39.24 29.3373 38.7524 30.1818L40.0515 30.9318C40.9291 29.4117 40.495 27.4725 39.053 26.4717L38.1977 27.704ZM36.3234 26.403L38.1977 27.704L39.053 26.4717L37.1787 25.1707L36.3234 26.403ZM36.1353 24C36.1353 24.5696 36.0923 25.1287 36.0095 25.6744L37.4925 25.8994C37.5866 25.2795 37.6353 24.6452 37.6353 24H36.1353ZM36.0095 22.3257C36.0923 22.8713 36.1353 23.4304 36.1353 24H37.6353C37.6353 23.3548 37.5866 22.7205 37.4925 22.1006L36.0095 22.3257ZM38.1977 20.2961L36.3234 21.597L37.1787 22.8293L39.053 21.5283L38.1977 20.2961ZM38.7524 17.8182C39.24 18.6628 38.9988 19.74 38.1977 20.2961L39.053 21.5283C40.495 20.5275 40.9291 18.5884 40.0515 17.0682L38.7524 17.8182ZM37.2303 15.1818L38.7524 17.8182L40.0515 17.0682L38.5293 14.4318L37.2303 15.1818ZM34.8071 14.4232C35.6892 14.0075 36.7427 14.3373 37.2303 15.1818L38.5293 14.4318C37.6517 12.9117 35.7553 12.318 34.1675 13.0664L34.8071 14.4232ZM32.7155 15.4091L34.8071 14.4232L34.1675 13.0664L32.076 14.0522L32.7155 15.4091ZM29.062 13.6784C30.1032 14.0811 31.0686 14.637 31.9304 15.3189L32.8611 14.1425C31.883 13.3687 30.7866 12.7371 29.6031 12.2794L29.062 13.6784ZM28.3917 10.7193L28.5852 13.0412L30.08 12.9166L29.8865 10.5947L28.3917 10.7193ZM26.5232 9C27.4983 9 28.3107 9.74749 28.3917 10.7193L29.8865 10.5947C29.7407 8.84549 28.2785 7.5 26.5232 7.5V9ZM23.4789 9H26.5232V7.5H23.4789V9Z"
                        fill="#9A3374"
                      />
                      <circle
                        cx="25.0723"
                        cy="24"
                        r="5.25"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="square"
                      />
                    </svg>
                  </div>
                  <div>Нарушение двигательной функции</div>
                </div>
                <div class="d-flex mb-4" style="align-items: center">
                  <div class="mr-2" style="flex-shrink: 0">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="25"
                        cy="25"
                        r="24.25"
                        stroke="#830051"
                        stroke-width="1.5"
                      />
                      <path
                        d="M10 20.4999C11.8333 17.8332 17.4 13.8999 25 19.4999C32.6 25.0999 37.8333 19.8333 39.5 16.5"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10 26.9999C11.8333 24.3332 17.4 20.3999 25 25.9999C32.6 31.5999 37.8333 26.3333 39.5 23"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10 32.9999C11.8333 30.3332 17.4 26.3999 25 31.9999C32.6 37.5999 37.8333 32.3333 39.5 29"
                        stroke="#9A3374"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div>Деформации/ косметические дефекты</div>
                </div>
              </div>
            </div>
          </div>
          <div class="title-4 mb-4" style="color: #830051">
            Диагностика плексиформных нейрофибром
          </div>
          <div class="d-md-flex">
            <div class="mr-4 mr-sm-0 mb-sm-4">
              <b class="d-block mb-4">Осмотр и пальпация<sup>6,23</sup>:</b>
              <ul class="mb-4">
                <li>
                  над поверхностными ПН могут отмечаться гипертрихоз,
                  гиперпигментация и истончение кожи;
                </li>
                <li>
                  при пальпации поверхностные ПН могут напоминать «мешок с
                  червями» или иметь мягкую консистенцию.
                </li>
              </ul>
              <b class="d-block mb-4"
                >Инструментальные методы
                обследования<sup>6,12,14,24,25</sup>:</b
              >
              <ul class="mb-4">
                <li>
                  биопсия рутинно не применяется, показана при подозрении на
                  озлокачествление;
                </li>
                <li>
                  диагноз ставят на основании визуализационных методов
                  обследования (МРТ, УЗИ);
                </li>
                <li>золотой стандарт диагностики ПН – МРТ.</li>
              </ul>
            </div>
            <div style="flex-basis: 40%; max-width: 170px">
              <picture>
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/7_mob.jpg
                  `"
                  media="(max-width: 767px)"
                />
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/7_tab.jpg
                  `"
                  media="(max-width: 1220px)"
                />
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/7.jpg
                  `"
                  media="(min-width: 1221px)"
                />
                <img
                  class="mb-4"
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/7.jpg`"
                />
              </picture>
            </div>
          </div>
          <div class="koselugo-tabs__block">
            <div class="koselugo-tabs__block-title">
              <b>Как могут выглядеть плексиформные нейрофибромы</b>
            </div>
            <div
              class="
                d-inline-flex
                px-4
                ml-auto
                mt-n-11 mt-sm-auto
                koselugo-tabs__block-button
                button button_empty-pink button_small
              "
              @click="currentModal = 0"
            >
              Подробнее
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="ml-2"
              >
                <path
                  d="M6 3L11 8L6 13"
                  stroke="#830051"
                  stroke-linecap="square"
                ></path>
              </svg>
            </div>
          </div>
          <div class="d-xl-flex d-none mt-4">
            <div style="flex-basis: 60%; max-width: 300px">
              <img
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/8.jpg`"
              />
            </div>
            <div class="ml-4">
              <b class="d-block mb-4"
                >Ультразвуковое исследование (УЗИ)<sup>27-31</sup>:</b
              >
              <ul class="mb-4">
                <li>
                  УЗИ может рассматриваться, как метод диагностики первой линии
                  по причине доступности и невысокой стоимости.
                </li>
                <li>
                  При исследовании узловых ПН на УЗИ визуализируются
                  гипоэхогенные очаги с гиперэхогенным центром.
                </li>
                <li>
                  УЗИ не позволяет дифференцироват ПН и ЗООПН (для которых также
                  характерна смешанная эхогенность).
                </li>
              </ul>
            </div>
          </div>
          <div class="d-xl-none d-block mt-4">
            <div class="mb-4">
              <b class="d-block mb-4"
                >Ультразвуковое исследование (УЗИ)<sup>27-31</sup>:</b
              >
              <ul class="mb-4">
                <li>
                  УЗИ может рассматриваться, как метод диагностики первой линии
                  по причине доступности и невысокой стоимости.
                </li>
                <li>
                  При исследовании узловых ПН на УЗИ визуализируются
                  гипоэхогенные очаги с гиперэхогенным центром.
                </li>
                <li>
                  УЗИ не позволяет дифференцироват ПН и ЗООПН (для которых также
                  характерна смешанная эхогенность).
                </li>
              </ul>
            </div>
            <div style="flex-basis: 40%; max-width: 300px">
              <picture>
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/8_mob.jpg
                  `"
                  media="(max-width: 767px)"
                />
                <source
                  :srcset="`
                    https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/8_tab.jpg
                  `"
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  style="width: auto; max-width: 300px"
                  :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/koselugo/8_tab.jpg`"
                />
              </picture>
            </div>
          </div>
          <ol class="mt-4 mb-8 pl-5">
            <li style="color: #830051">
              <span style="color: #3c4242"
                >Гиперэхогенный центр очага соответствует нервным
                волокнам.</span
              >
            </li>
            <li style="color: #830051">
              <span style="color: #3c4242"
                >Гипоэхогенный контур очага соответствует увеличенной оболочке
                периферического нерва.</span
              >
            </li>
          </ol>
          <div class="title-4 mb-4" style="color: #830051">
            МРТ – «золотой стандарт» диагностики плексиформных нейрофибром<sup
              >25</sup
            >
          </div>
          <div class="d-md-flex">
            <div class="mr-4 mr-xs-0" style="flex-basis: 50%">
              <b class="d-block mb-4"
                >Цели МРТ у пациентов с ПН<sup>30,33-35</sup>:</b
              >
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <path
                      d="M15 36V14C15 12.8954 15.8954 12 17 12H27.6716C28.202 12 28.7107 12.2107 29.0858 12.5858L31.5 15L35.3599 18.5795C35.7681 18.9579 36 19.4893 36 20.0459V36C36 37.1046 35.1046 38 34 38H17C15.8954 38 15 37.1046 15 36Z"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M28 12V19C28 19.5523 28.4477 20 29 20H36"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M19 27H32"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M19 32H32"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M22 16V22.5"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M18.75 19.25H25.25"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>первичная диагностика ПН;</div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <rect
                      x="11.0605"
                      y="29.9718"
                      width="26.2801"
                      height="12.39"
                      rx="6.19502"
                      transform="rotate(-46.0216 11.0605 29.9718)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                    />
                    <path
                      d="M20.5 20.5L28.9211 29"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>оценка ответа на терапию;</div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="11"
                      cy="11"
                      r="11"
                      transform="matrix(-1 0 0 1 36 14)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <path
                      d="M17 33L10 40"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <circle
                      cx="25"
                      cy="22"
                      r="2.25"
                      stroke="#9A3374"
                      stroke-width="1.5"
                    />
                    <path
                      d="M29.3758 29.5C29.7206 29.5 30.0034 29.2198 29.9678 28.877C29.9151 28.3686 29.7981 27.8698 29.6194 27.3952C29.3681 26.728 28.9998 26.1216 28.5355 25.6109C28.0712 25.1002 27.52 24.6951 26.9134 24.4187C26.3068 24.1423 25.6566 24 25 24C24.3434 24 23.6932 24.1423 23.0866 24.4187C22.48 24.6951 21.9288 25.1002 21.4645 25.6109C21.0002 26.1216 20.6319 26.728 20.3806 27.3952C20.2019 27.8698 20.0849 28.3686 20.0322 28.877C19.9966 29.2198 20.2794 29.5 20.6242 29.5C20.9689 29.5 21.2438 29.2193 21.2912 28.8778C21.3366 28.5499 21.418 28.2285 21.5339 27.9207C21.7224 27.42 21.9988 26.9651 22.3471 26.5819C22.6955 26.1986 23.1091 25.8947 23.5643 25.6873C24.0195 25.4799 24.5073 25.3731 25 25.3731C25.4927 25.3731 25.9805 25.4799 26.4357 25.6873C26.8909 25.8947 27.3045 26.1986 27.6529 26.5819C28.0012 26.9651 28.2776 27.42 28.4661 27.9207C28.582 28.2285 28.6634 28.5499 28.7088 28.8778C28.7562 29.2193 29.0311 29.5 29.3758 29.5Z"
                      fill="#9A3374"
                    />
                  </svg>
                </div>
                <div>мониторинг состояния ПН в динамике;</div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13 16C13 16 13 16.5 13 24C13 34.1439 22.0455 38 25 38C27.9545 38 37 34.1439 37 24C37 16 37 16 37 16C37 16 33 16 30 15C27 14 25 12 25 12C25 12 23 14 20 15C17 16 13 16 13 16Z"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M31 21L24 29L21 25"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div>исключение малигнизации ПН.</div>
              </div>
            </div>
            <div class="d-none d-md-block pl-4" style="border-left: 2px solid #B2B4B4; flex-basis: 50%">
              <b class="d-block mb-4"
                >МРТ характеристики ПН<sup>24,32,36-38</sup>:</b
              >
              <div class="d-flex mb-4">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="11"
                      cy="11"
                      r="11"
                      transform="matrix(-1 0 0 1 36 14)"
                      stroke="#B36697"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="2.5"
                      cy="2.5"
                      r="2.5"
                      transform="matrix(-1 0 0 1 30 22)"
                      stroke="#CC99B9"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
                <div>
                  <b
                    >на Т2 взвешенных изображениях можно увидеть характерный
                    признак ПН</b
                  >
                  – гиперинтенсивный очаг со снижением интенсивности сигнала в
                  центре, напоминающий кольцо (чаще наблюдают при визуализации
                  глубоких ПН);
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.9336 42.2391C20.4553 37.6739 19.6945 35.3913 21.2162 33.1086C22.6438 30.9058 25.3989 25.3 24.9989 20.5C24.4989 14.5 27.4989 8 28.4989 7"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M25 15.5C26.3333 16.5 28.7 20 27.5 26C26 33.5 23.5 33 21.5 36.5C19.9 39.3 19.1667 41.3333 19 42"
                      stroke="#9A3374"
                      stroke-width="1.5"
                    />
                    <path
                      d="M33.5715 11.0002C30.0078 13.6429 28.7158 16.0628 26.2957 14.7708"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M18.499 6.50023C22.0628 9.14286 22.079 18.2922 24.499 17.0002"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>
                  по ходу роста ПН может визуализироваться грубое
                  <b>диффузное утолщение нерва</b>;
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="2.5"
                      cy="2.5"
                      r="2.5"
                      transform="matrix(-1 0 0 1 21 14)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="4"
                      cy="4"
                      r="4"
                      transform="matrix(-1 0 0 1 39 17)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="7"
                      cy="7"
                      r="7"
                      transform="matrix(-1 0 0 1 30 25)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
                <div>
                  очаги могут быть единичными и множественными,
                  <b>чаще множественные.</b>
                </div>
              </div>
            </div>
             <div class="d-md-none">
              <b class="d-block mb-4"
                >МРТ характеристики ПН<sup>24,32,36-38</sup>:</b
              >
              <div class="d-flex mb-4">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="11"
                      cy="11"
                      r="11"
                      transform="matrix(-1 0 0 1 36 14)"
                      stroke="#B36697"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="2.5"
                      cy="2.5"
                      r="2.5"
                      transform="matrix(-1 0 0 1 30 22)"
                      stroke="#CC99B9"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
                <div>
                  <b
                    >на Т2 взвешенных изображениях можно увидеть характерный
                    признак ПН</b
                  >
                  – гиперинтенсивный очаг со снижением интенсивности сигнала в
                  центре, напоминающий кольцо (чаще наблюдают при визуализации
                  глубоких ПН);
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <path
                      d="M18.9336 42.2391C20.4553 37.6739 19.6945 35.3913 21.2162 33.1086C22.6438 30.9058 25.3989 25.3 24.9989 20.5C24.4989 14.5 27.4989 8 28.4989 7"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M25 15.5C26.3333 16.5 28.7 20 27.5 26C26 33.5 23.5 33 21.5 36.5C19.9 39.3 19.1667 41.3333 19 42"
                      stroke="#9A3374"
                      stroke-width="1.5"
                    />
                    <path
                      d="M33.5715 11.0002C30.0078 13.6429 28.7158 16.0628 26.2957 14.7708"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M18.499 6.50023C22.0628 9.14286 22.079 18.2922 24.499 17.0002"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                <div>
                  по ходу роста ПН может визуализироваться грубое
                  <b>диффузное утолщение нерва</b>;
                </div>
              </div>
              <div class="d-flex mb-4" style="align-items: center">
                <div class="mr-2" style="flex-shrink: 0">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25"
                      cy="25"
                      r="24.25"
                      stroke="#830051"
                      stroke-width="1.5"
                    />
                    <circle
                      cx="2.5"
                      cy="2.5"
                      r="2.5"
                      transform="matrix(-1 0 0 1 21 14)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="4"
                      cy="4"
                      r="4"
                      transform="matrix(-1 0 0 1 39 17)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                    <circle
                      cx="7"
                      cy="7"
                      r="7"
                      transform="matrix(-1 0 0 1 30 25)"
                      stroke="#9A3374"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
                <div>
                  очаги могут быть единичными и множественными,
                  <b>чаще множественные.</b>
                </div>
              </div>
            </div>
          </div>
           <div class="koselugo-tabs__body mt-4">
            <div
              class="koselugo-tabs__block"
              v-for="(block, ind) in modals[1].filter((el) => !el.hide)"
              :key="ind"
            >
              <div
                class="koselugo-tabs__block-title"
                :class="{ 'mb-0': !block.text }"
                v-html="block.title"
              ></div>
              <div
                class="
                  d-inline-flex
                  px-4
                  ml-auto
                  mt-auto
                  koselugo-tabs__block-button
                  button button_empty-pink button_small
                "
                @click="currentModal = ind+1"
              >
                Подробнее
                <svg
                  class="ml-2"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 3L11 8L6 13"
                    stroke="#830051"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="mt-4 text-2">
            Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменений нет.
          </div>

          <div class="koselugo-tabs__modal" v-if="currentModal !== null">
            <div
              class="koselugo-tabs__modal-overlay"
              @click="currentModal = null"
            ></div>
            <div class="koselugo-tabs__modal-content">
              <div class="koselugo-tabs__modal-head">
                <div
                  class="koselugo-tabs__modal-title"
                  v-html="modals[1][currentModal].title"
                ></div>
                <div
                  class="koselugo-tabs__modal-close"
                  @click="currentModal = null"
                >
                  <svg
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 7L25 25"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                    <path
                      d="M25 7L7 25"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div
                class="koselugo-tabs__modal-body"
                v-html="modals[1][currentModal].text"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleCarousel from "@/components/pageComponents/SimpleCarousel.vue";
import Vue from "vue";
import { bus } from "@/main";
export default {
  name: "KoselugoTabs",
  data: () => ({
    activeTab: 0,
    currentModal: null,
  }),
  computed: {
    modals() {
      return [
        [
          {
            title: `6 и более <b>гиперпигментированных пятен</b> (пятна «кофе с молоком»)*:
            <ul>
            <li>в препубертатном периоде – размером 5 мм и более;</li>
            <li>в постпубертатном периоде – размером 15 мм и более.</li>
            </ul>`,
            modalTitle: "Пятна цвета «кофе с молоком»<sup>6-8,12,13</sup>",
            text: `<div class="koselugo-tabs__modal-row">
              <div class="koselugo-tabs__modal-row-text">
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Частота:</b>
                  </div>
                  <div>>99% пациентов с НФ1.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Возраст появления:</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">в течение первого года жизни;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">размер и количество могут увеличиваться до 5–7 лет.</span></li>
                  </ul>
                  </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Осмотр:</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">гиперпигментированные пятна, плоские, овальной или круглой формы;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">обычно сглаженные края;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">цвет от светло — до темно-коричневого;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">важно обращать внимание на количество и размеры пятен;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">2–3 светло-коричневых пигментных пятна и менее — вариант нормы.</span></li>
                  </ul>
                </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Пальпация:</b>
                  </div>
                  <div>безболезненные.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Методы обследования:</b>
                  </div>
                  <div>осмотр и пальпация кожных покровов.</div>
                </div>
              </div>
              <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal7.jpg" />
              </div>
            </div>
            <div class="text-2">
              Фото: Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменений нет.
            </div>`,
          },
          {
            title: `2 и более <b>узелков Лиша</b> на радужной оболочке (гамартомы радужки), выявленных при осмотре с помощью щелевой лампы, или 2 и более аномалии сосудистой оболочки глаза (хороидальные гамартомы), определяемые как высокорефлективные узелки (включения) на ОКТ (оптическая когерентная томография) или при проведении лазерной сканирующей офтальмоскопии`,
            modalTitle: "Гамартомы радужки (узелки Лиша)<sup>6-8,12,13</sup>",
            text: `<div class="koselugo-tabs__modal-row">
              <div class="koselugo-tabs__modal-row-text">
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Частота:</b>
                  </div>
                  <div>>95% пациентов с НФ1.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Возраст появления:</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">до 3 лет - редко;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">дети школьного возраста ~50%;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">подростки – у большинства.</span></li>
                  </ul>
                  </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Клинические проявления:</b>
                  </div>
                  <div>
                    не влияют на зрение.
                </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Методы обследования:</b>
                  </div>
                  <div>только офтальмологическое обследование (осмотр в щелевой лампе).</div>
                </div>
              </div>
              <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2.jpg" />
              </div>
            </div>
            <div class="text-2">
              Фото: Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменений нет.
            </div>`,
          },
          {
            title: `<b>Глиома зрительного пути</b>`,
            modalTitle: "Глиома зрительного пути<sup>6-8,12-14</sup>",
            text: `<div class="koselugo-tabs__modal-row">
              <div class="koselugo-tabs__modal-row-text">
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Частота:</b>
                  </div>
                  <div>15-20% пациентов с НФ1.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Возраст появления:</b>
                  </div>
                  <div>
                    с 1 года жизни до 8 лет.
                  </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Клинические проявления (у 5% пациентов):</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">снижение остроты / потеря зрения;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">проптоз (экзофтальм);</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">страбизм (косоглазие).</span></li>
                  </ul>
                </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Методы обследования:</b>
                  </div>
                  <div> <ul>
                    <li style="color: #830051;"><span style="color: #3C4242;">офтальмологическое обследование (оценка остроты зрения, фундоскопия);</span></li>
                    <li style="color: #830051;"><span style="color: #3C4242;">МРТ головы.</span></li>
                </ul></div>
                </div>
              </div>
              <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal3.jpg" />
              </div>
            </div>
            <div class="text-2">
              Фото: Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменений нет.
            </div>`,
          },
          {
            title: `2 или более <b>нейрофибром</b> любого типа или 1 <b>плексиформная нейрофиброма**</b>`,
            modalTitle: "Нейрофибромы при НФ1<sup>6,12</sup>",
            text: `<div class="text-1 mb-4" style="color: #830051;">Кожные и подкожные нейрофибромы<sup>6-8,12,13,15</sup></div>
              <div class="text-1 mb-4">Это доброкачественные опухоли, которые произрастают из терминальных ветвей нервов кожи.</div>
              <div class="koselugo-tabs__modal-row mb-4">
                <div class="koselugo-tabs__modal-row-text">
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Частота:</b>
                    </div>
                    <div>98% пациентов с НФ1.</div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Возраст появления:</b>
                    </div>
                    <div>
                      <ul>
                        <li style="color: #830051;"><span style="color: #3C4242;">возникают в подростковом возрасте;</span></li>
                        <li style="color: #830051;"><span style="color: #3C4242;">в течение жизни число и размер увеличиваются. </span></li>
                      </ul>
                    </div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Клинические проявления (у 5% пациентов):</b>
                    </div>
                    <div>
                      <ul>
                        <li style="color: #830051;"><span style="color: #3C4242;">округлые образования размером до нескольких сантиметров;</span></li>
                        <li style="color: #830051;"><span style="color: #3C4242;"><b>кожные</b> – мягкие, смещаются вместе с кожей;</span></li>
                        <li style="color: #830051;"><span style="color: #3C4242;"><b>подкожные</b> – плотные, не смещаются, но кожа над ними смещается.</span></li>
                      </ul>
                    </div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Локализация:</b>
                    </div>
                    <div>
                      <ul>
                        <li style="color: #830051;"><span style="color: #3C4242;">кожных – ограничена слоями кожи;</span></li>
                        <li style="color: #830051;"><span style="color: #3C4242;">подкожных – ограничена подкожно-жировой клетчаткой.</span></li>
                      </ul>
                    </div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Методы обследования:</b>
                    </div>
                    <div>
                      осмотр и пальпация.
                    </div>
                  </div>
                </div>
                  <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal5.jpg" />
                </div>
              </div>
              <div class="text-1 mb-4" style="color: #830051;">Плексиформные нейрофибромы (ПН)<sup>6-8,12,13</sup></div>
              <div class="text-1 mb-4">Это доброкачественные опухоли оболочек периферических нервов.</div>
              <div class="koselugo-tabs__modal-row mb-4">
                <div class="koselugo-tabs__modal-row-text">
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Частота:</b>
                    </div>
                    <div>30-50% пациентов с НФ1.</div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Возраст появления:</b>
                    </div>
                    <div>
                      любой, могут быть врождёнными. У детей и подростков могут увеличиваться в размере, вызывая клиническую симптоматику.
                    </div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Могут приводить к значимым осложнениям</b>
                    </div>
                    <div>
                      
                    </div>
                  </div>
                  <div class="koselugo-tabs__modal-row-item">
                    <div>
                      <b>Могут озлокачествляться</b>
                    </div>
                    <div>
                    
                    </div>
                  </div>
                </div>
                  <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal6.jpg" />
                </div>
              </div>
              <div class="text-2">
                <sup>а</sup> Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменения: изображения обрезаны. Добавлены подписи на русском языке.
              </div>
              <div class="text-2">
                <sup>b</sup> Basso E., Opocher E., Bassetto F., Grigatti M., Montanari A., Ferraresi S., Chiara F. Therapeutic Approach to Plexiform Neurofibromas. In: Neurofibromatosis. Chapter 4. IntechOpen. 2023. Doi: 10.5772/intechopen.1001471
              Лицензия: https://creativecommons.org/licenses/by/3.0/

              </div>`,
          },
          {
            title: `Множественные, похожие на <b>веснушки</b>, гиперпигментированные пятна в подмышечной или паховой областях*`,
            modalTitle:
              "Пятна, похожие на веснушки, в подмышечной / паховой областях<sup>6-8,12,13</sup>",
            text: `<div class="koselugo-tabs__modal-row">
              <div class="koselugo-tabs__modal-row-text">
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Частота:</b>
                  </div>
                  <div>85% пациентов с НФ1.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Возраст появления:</b>
                  </div>
                  <div>5 лет и старше.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Осмотр:</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">пигментированные пятна размером до 1-2 мм;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">такие пятна на участках кожи, скрытых от солнечных лучей, не характерны для лиц без НФ1.</span></li>
                  </ul>
                </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Методы обследования:</b>
                  </div>
                  <div>осмотр и пальпация кожных покровов.</div>
                </div>
              </div>
              <div class="koselugo-tabs__modal-row-img">
                <img src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal1.jpg" />
              </div>
            </div>
            <div class="text-2">
              Фото: Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменений нет.
            </div>`,
          },
          {
            title: `Характерные <b>изменения костей</b> (такие, как дисплазия крыла клиновидной кости**, дисплазия / или дугообразная деформация / или ложные суставы длинных трубчатых костей)`,
            modalTitle: "Характерные изменения костей<sup>6-8,12,13</sup>",
            text: `<div>
              <div class="koselugo-tabs__modal-row-text">
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Частота:</b>
                  </div>
                  <div>~10% пациентов с НФ1.</div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Возраст появления:</b>
                  </div>
                  <div>
                    врожденные (кроме ложных суставов, которые возникают в результате несросшихся переломов).
                  </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Клинические проявления (у 5% пациентов):</b>
                  </div>
                  <div>
                    <ul>
                      <li style="color: #830051;"><span style="color: #3C4242;">истончение кортикального слоя /дугообразная деформация длинных трубчатых костей;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">ложные суставы;</span></li>
                      <li style="color: #830051;"><span style="color: #3C4242;">дисплазия крыльев клиновидной кости.</span></li>
                  </ul>
                </div>
                </div>
                <div class="koselugo-tabs__modal-row-item">
                  <div>
                    <b>Методы обследования:</b>
                  </div>
                  <div> <ul>
                    <li style="color: #830051;"><span style="color: #3C4242;">рентгенография, КТ;</span></li>
                    <li style="color: #830051;"><span style="color: #3C4242;">консультация ортопеда.</span></li>
                </ul></div>
                </div>
              </div>
            </div>
            <img class="mt-4" src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal4.jpg" />
            <div class="text-1 mt-4 mb-4">
              Дисплазию крыльев клиновидной кости в сочетании с ПН орбиты следует рассматривать, как соответствие 1 критерию диагноза НФ1.
            </div>
            <div class="text-2">
              Фото: Legius, E., Messiaen, L., Wolkenstein, P. et al. Revised diagnostic criteria for neurofibromatosis type 1 and Legius syndrome: an international consensus recommendation. Genet Med 23, 1506–1513 (2021). https://doi.org/10.1038/s41436-021-01170-5; Лицензия: https://creativecommons.org/licenses/by/4.0/; Изменения: изображения обрезаны. Добавлены подписи на русском языке.
            </div>`,
          },
          {
            title: `<b>Гетерозиготная патогенная мутация</b> в гене NF1 (с фракцией вариантного аллеля от 50%), выявляемая в тканях без видимых клинических признаков, таких как белые кровяные клетки`,
          },
        ],
        [
           {
            title: "Как могут выглядеть плексиформные нейрофибромы",
            hide: true,
            text: `<div class="simple-carousel__container">
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-1_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-1_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-1.jpg"
                />
              </picture>
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-2_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-2_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-0-2.jpg"
                />
              </picture>
            </div>`,
          },
          {
            title: "<b>ПН запястья на МРТ (Т2 взвешенные изображения с подавлением жира)<sup>32</sup></b>",
            text: `
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-1_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-1_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-1.jpg"
                />
              </picture> 
            `,
          },
          {
            title: "<b>МРТ-исследование мягких тканей бедер – нижние конечности</b>",
            text: `
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-4_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-4_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-4.jpg"
                />
              </picture>
            `,
          },
          {
            title: "<b>МРТ-исследование мягких тканей головы и шеи</b>",
            text: `<div class="simple-carousel__container">
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-1_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-1_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-1.jpg"
                />
              </picture>
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-2_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-2_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-2-2.jpg"
                />
              </picture>
            </div>`,
          },
          {
            title: "<b>МРТ-исследование орбиты. ПН периорбитальной области</b>",
            text: `<div class="simple-carousel__container">
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-1_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-1_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-1.jpg"
                />
              </picture>
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-2_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-2_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-5-2.jpg"
                />
              </picture>
            </div>`,
          },
          {
            title: `<b>МРТ-исследование брюшной полости и малого таза</b>`,
            text: `<div class="simple-carousel__container">
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-1_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-1_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-1.jpg"
                />
              </picture>
              <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-2_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-2_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-2.jpg"
                />
              </picture>
               <picture>
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-3_mob.jpg
                  "
                  media="(max-width: 767px)"
                />
                <source
                  srcset="
                    https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-3_tab.jpg
                  "
                  media="(max-width: 1220px)"
                />
                <img
                  class="mb-4"
                  src="https://storage.yandexcloud.net/${this.$root.backetName}/media/content/koselugo/modal2-3-3.jpg"
                />
              </picture>
            </div>`,
          },
        ],
      ];
    },
  },
  methods: {
    choiceTab(ind) {
      this.activeTab = ind;
      setTimeout(() => {
        this.initSlider();
      }, 100);
    },
    initSlider() {
      const vm = this;
      if (
        this.$refs[`koselugo-tabs_${this._uid}`] &&
        this.$refs[`koselugo-tabs_${this._uid}`].querySelector(
          ".simple-carousel__container"
        )
      ) {
        this.$refs[`koselugo-tabs_${this._uid}`]
          .querySelectorAll(".simple-carousel__container:not(.loaded)")
          .forEach((slider) => {
            let ComponentClass = Vue.extend(SimpleCarousel);
            let instance = new ComponentClass({
              propsData: {
                Slides: Array.from(slider.children),
                color: "#830051",
                autoplay: slider.getAttribute("data-autoplay"),
              },
            });
            instance.$mount(); 
            slider.innerHTML = "";
            slider.appendChild(instance.$el);
            slider.classList.add("loaded");
          });
      }
    },
  },
  mounted() {
    this.initSlider();
  },
  watch: {
    currentModal() {
      bus.$emit("scrollLock", this.currentModal !== null);
      this.$nextTick(() => {
        this.initSlider();
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.koselugo-tabs {
  &__head {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 32px;
    margin-bottom: 16px;
    @media screen and (max-width: 1199px) {
      grid-gap: 16px;
    }
    @media screen and (max-width: 767px) {
      grid-gap: 8px;
    }
  }

  &__item {
    cursor: pointer;
    padding: 20px 16px;
    background-color: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #1f1f1f;
    height: 100%;
    transition: 0.3s;
    @media screen and (max-width: 1199px) {
      padding: 20px 8px;
    }
    @media screen and (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 8px;
      font-size: 12px;
      line-height: 16px;
    }

    &_active {
      height: calc(100% + 16px);
      background-color: #fbf6fb;
      border-color: #fbf6fb;
      border-radius: 8px 8px 0 0;
    }

    & svg {
      flex-shrink: 0;
    }
  }

  &__content {
    padding: 24px 16px;
    background-color: #fbf6fb;
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media screen and (max-width: 767px) {
      grid-template-columns: 100%;
    }
  }

  &__block {
    padding: 16px 24px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #f8f8f8;
    border: 1px solid #6aa2b9;
    transition: 0.3s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &:last-child {
      grid-column-start: 1;
      grid-column-end: 3;

      @media screen and (max-width: 767px) {
        grid-column-start: auto;
        grid-column-end: auto;
      }
    }

    &-title {
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #3c4242;
      margin-bottom: 16px;

      & b {
        font-weight: 500;
      }

      & ul {
        margin-top: 16px;
        list-style-type: disc;
        padding-left: 30px;
      }
    }
  }

  &__modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999999999999;

    &-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      overflow: hidden;
    }

    &-content {
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 2;
      transform: translate(-50%, -50%);
      max-height: 80%;
      max-width: 800px;
      width: 100%;
      height: fit-content;
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 1219px) {
        max-width: 90%;
      }
    }

    &-head {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 16px 24px;
      border-radius: 8px 8px 0 0;
      background-color: #9a3374;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
      color: #fff;
      margin-right: 16px;
    }

    &-close {
      margin-left: auto;
      cursor: pointer;
    }

    &-body {
      padding: 24px;
      border-radius: 0 0 8px 8px;
      background-color: #f8f8f8;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #3c4242;
      overflow-y: auto;
    }
  }
}
</style>

<style lang="scss">
.koselugo-tabs {
  &__modal-row {
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: 1fr 220px;
    column-gap: 32px;

    @media screen and (max-width: 1220px) {
      display: flex;
      flex-direction: column-reverse;
    }

    &-img {
      & img {
        @media screen and (max-width: 1220px) {
          width: 250px;
          max-width: 100%;
          margin-bottom: 16px;
        }
      }
    }

    &-item {
      &:not(:last-child) {
        margin-bottom: 16px;
      }
      display: grid;
      grid-template-columns: 0.4fr 0.6fr;
      column-gap: 32px;

      @media screen and (max-width: 1220px) {
        grid-template-columns: 100%;
        row-gap: 8px;
      }
    }
  }
}
</style>
